import { Modal, Text, Flex, Button, ThemeIcon } from "@mantine/core";
import { IconCircleCheck, IconEye } from "@tabler/icons-react";
import { useNavigate } from "react-router-dom";

interface VerificationSubmittedModalProps {
  opened: boolean;
  onClose: () => void;
}

export default function VerificationSubmittedModal({ opened, onClose }: VerificationSubmittedModalProps) {
  const navigate = useNavigate();

  const handleReviewProfile = () => {
    onClose();
    navigate("/profile");
  };

  return (
    <Modal opened={opened} onClose={onClose} withCloseButton={false} centered size="lg">
      <Flex direction="column" align="center" py="md">
        <ThemeIcon size={64} radius={64} color="green" variant="light" mb="md">
          <IconCircleCheck size={36} />
        </ThemeIcon>

        <Text fw={600} fz="lg" c="slate.8" mb="xs">
          Profile Submitted for Verification
        </Text>

        <Text fz="sm" c="slate.5" ta="center" mb="xl" maw={350}>
          Your profile has been successfully submitted and is currently under review. Our team will verify your details,
          and you'll be notified once the process is complete.
        </Text>

        <Button fullWidth onClick={handleReviewProfile} leftSection={<IconEye size={18} />}>
          Review Profile
        </Button>
      </Flex>
    </Modal>
  );
}
